export default __webpack_public_path__ + "static/media/virtual-bg22.c959b6c1.png";